const cookies = {
  create(name, value, days) {
    let expires: any

    // If days is present then add the value supplied to the expires string
    // else we dont supply the expires string.
    if (days) {
      const expireDate = new Date()
      expireDate.setDate(expireDate.getDate() + days)
      expires = `; expires=${expireDate.toUTCString()}`
    } else {
      expires = ''
    }

    document.cookie = `${name}=${value}${expires}; path=/`
  },

  read(theName) {
    const name = `${theName}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  },

  delete(name) {
    // This resets the cookie with the supplied name.
    cookies.create(name, '', -1)
  },
}

export default cookies
